import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import {
  ValoreEconomicoAltriImportiFormComponent
} from '../../../form/sez-economica/valore-economico-altri-importi-form.component';
import { Petitum } from '../../../models/petitum';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';

@Component({
    templateUrl: '../../../form/sez-economica/valore-economico-altri-importi-form.component.html',
  selector: 'div [sezione-economica-altri-importi-edit]',
})

export class SezioneEconomicaAltriImportiEditComponent extends ValoreEconomicoAltriImportiFormComponent implements OnInit {
  petitum: Petitum;
  sezione: SezioneEconomica;
  urlUpdate: string;
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Modifica dati - Altri importi');
    this.isInserimento(false);
  }

  getPetitum() {
    return this.petitum;
  }

  getRequest(petitum: Petitum) {
    this.operationService.updatePetitumAltriImporti(this.urlUpdate, petitum , this.sezione.id)
      .subscribe(response => this.datiResponse(response));
  }

  datiResponse(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica, petitum: Petitum, urlUpdate: string) {
    this.sezione = sezione;
    this.petitum = petitum;
    this.urlUpdate = urlUpdate;
    this.createForm();
    this.populateSelect();
  }

}
